import { useSelector } from 'react-redux';
import { kebabCase } from 'lodash';
import { selectIsWebInAppReportingFeatureFlagOn } from 'core/userContext';
import { metricSentenceCase } from 'modules/productAnalytics/utils';
import { HelpToggletip } from 'ui/tooltip';
import { Title, DataLarge } from './Styled';
import { ProgressBar } from './ProgressBar';
import { ProgressBarWithTooltip } from './ProgressBarWithTooltips';
import { WEB_INAPP_BREAKDOWN_UNSUPPORTED_METRICS } from '../constants';
import { MetricDefinitionWrapper } from './MetricDefinitionWrapper';

export const OverviewDeliveryProgressBarChart = ({ data }) => {
  const inAppFF = useSelector(selectIsWebInAppReportingFeatureFlagOn);

  return (
    <div data-test={`progress-bar-section-${kebabCase(data.name)}`} key={data.name}>
      <Title data-test={`metric-bar-title-${kebabCase(data.name)}`}>
        <MetricDefinitionWrapper metricName={data.name}>
          {metricSentenceCase(data.name)}
        </MetricDefinitionWrapper>
        {inAppFF && data.name === 'Total In-app sent' && (
          <div data-test="tooltip">
            <HelpToggletip
              iconProps={{ height: 20, width: 20 }}
              tooltipContent={
                WEB_INAPP_BREAKDOWN_UNSUPPORTED_METRICS.find(
                  (met) => met.mediumMetricName === 'TotalInAppSend',
                )?.tooltipContent
              }
              isInline
            />
          </div>
        )}
      </Title>
      <DataLarge data-test={`metric-bar-value-${kebabCase(data.name)}`}>
        {typeof data.value === 'number' ? data.value.toLocaleString() : data.value}
      </DataLarge>
      {inAppFF &&
      (data.name === 'Total In-apps delivered' || data.name === 'Total inbox impressions') ? (
        <ProgressBarWithTooltip data={data.progressData} total={data.value} />
      ) : (
        <ProgressBar data={data.progressData} />
      )}
    </div>
  );
};
